import cx from 'classnames';

import styles from './ExLeaseBadge.module.scss';

const EX_LEASE_LOGO_SRC = '/static/images/mobilize-logo.png';
const EX_LEASE_ALT = 'Mobilize';

interface ExLeaseBadgeProps {
	className?: string;
	size?: 'small' | 'large';
}

export const ExLeaseBadge: React.FC<ExLeaseBadgeProps> = ({ className = '', size = 'small' }) => (
	<div className={cx(styles.badge, { [styles.large]: size === 'large' }, className)} data-testid="ex-lease-badge">
		<img alt={EX_LEASE_ALT} className={styles.logo} src={EX_LEASE_LOGO_SRC} />
	</div>
);
